// Left-hand nav for the Calculation Results view: the 4 dashboard categories
// (Overview / Allocations / Distributions / Cash & Fees), each listing the
// groups within it that actually produced data for this calculation result.
// Mirrors reporting-hub/frontend/src/components/preflight/calculations/
// CategorySidebar.tsx - same props shape (categories/groupLabelById/
// selectedGroup/onSelectGroup), re-implemented with plain inline styles
// instead of Tailwind.
//
// NOTE: the fund-vs-platform scope switcher lives in GroupPanel.js, not
// here - that's what the real reporting-hub source does (the sidebar is
// group-selection only), even though a first read of the taxonomy might
// suggest scope belongs in the sidebar too.

import React from 'react';

const CategorySidebar = ({ categories, groupLabelById, selectedGroup, onSelectGroup }) => {
  return (
    <nav className="cr-category-sidebar">
      {categories.map((cat) => (
        <div key={cat.id} className="cr-category-group">
          <div className="cr-category-label">{cat.label}</div>
          <div>
            {cat.groups.map((groupId) => {
              const isSelected = selectedGroup === groupId;
              return (
                <button
                  key={groupId}
                  type="button"
                  onClick={() => onSelectGroup(groupId)}
                  className={`cr-category-item${isSelected ? ' is-selected' : ''}`}
                  aria-current={isSelected ? 'true' : undefined}
                >
                  {groupLabelById.get(groupId) || groupId}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </nav>
  );
};

export default CategorySidebar;
